<template>
    <div v-if="item && ready" class="md-content">
        <toolbar title="Gestion des Réglages" isSave="true" @save="dataSave" />
        <div class="md-mt-5 md-layout md-gutter md-alignment-top-center">
            <div class="md-layout-item md-size-90">
                <div class="md-layout-item ">
                    <md-tabs class="md-transparent">

                        <md-tab id="tab-Organisation" name="tab-Organisation" md-label="Organisation" md-icon="business">
                            <div class="md-layout">
                                <label class="md-layout-item md-size-25 md-small-size-90">Nom</label>
                                <md-field class="md-layout-item md-size-35 md-small-size-90">
                                    <md-input v-model="item.tenantSetting.name" type="text" />
                                </md-field>
                            </div>
                            <div class="md-layout">
                                <label class="md-layout-item md-size-25 md-small-size-90">Téléphone</label>
                                <md-field class="md-layout-item md-size-35 md-small-size-90">
                                    <md-input v-model.number="item.tenantSetting.phone" type="text" />
                                </md-field>
                            </div>

                            <div class="md-layout">
                                <label class="md-layout-item md-size-25 md-small-size-90">Addresse</label>
                                <div class="md-layout-item">
                                    <field-address  v-if="item.tenantSetting.address" v-bind:item.sync="item.tenantSetting.address" :includeType="false" :includeDescription="false"></field-address>
                                </div>
                            </div>


                            <div class="md-layout">
                                <label class="md-layout-item md-size-25 md-small-size-90">GST</label>
                                <md-field class="md-layout-item md-size-35 md-small-size-90">
                                    <md-input v-model="item.tenantSetting.gst" type="text" />
                                </md-field>
                            </div>

                            <div class="md-layout">
                                <label class="md-layout-item md-size-25 md-small-size-90">PST</label>
                                <md-field class="md-layout-item md-size-35 md-small-size-90">
                                    <md-input v-model="item.tenantSetting.pst" type="text" />
                                </md-field>
                            </div>

                            <div class="md-layout md-mt-3">
                                <label class="md-layout-item md-size-25 md-small-size-90">Image en-tête</label>
                                <field-image v-if="item && item.tenantSetting" v-bind:item.sync="item.tenantSetting" property="base64LogoHeader" type="Image" :readonly="false"  />
                            </div>

                            <div class="md-layout">
                                <label class="md-layout-item md-size-25 md-small-size-90">Image pied de page</label>
                                <field-image v-if="item && item.tenantSetting" v-bind:item.sync="item.tenantSetting" property="base64LogoFooter" type="Image" :readonly="false"  />
                            </div>

                        </md-tab>

                        <md-tab id="tab-Settings" name="tab-Settings" md-label="Réglages" md-icon="settings">
                            <md-content class="md-transparent" v-for="setting in settings">
                                <div v-if="settings" class="md-layout-item md-layout md-scrollbar ">
                                    <label class="md-layout-item md-size-25 md-small-size-90">
                                        {{setting.title}}
                                    </label>
                                    <md-field class="md-layout-item md-size-35 md-small-size-90">
                                        <md-input v-if="setting.source == null" id="txtValue" v-model="setting.value" type="text" />
                                        <md-select v-if="setting.source != null" v-model="setting.value" name="category" id="category" md-dense>
                                            <md-option v-for="(category, index) in setting.categories" :value="category.id">{{category.title}}</md-option>
                                        </md-select>
                                    </md-field>
                                </div>
                            </md-content>
                        </md-tab>
                    </md-tabs>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
    .btnHeight {
        height: auto;
        margin: 30px;
    }

    label {
        padding-top: 22px;
        margin: 4px 0 24px;
        font-size: 16px;
    }

    .md-content.md-theme-default.md-transparent {
        background-color: transparent !important;
    }

    /*a voir, probleme car deux contents dans la page*/
    /*    .md-content {
        max-width: 400px;
        max-height: 200px;
        overflow: auto;
    }*/

    .text {
        text-transform: none;
    }
</style>
<script>
    import baseToolbar from '@/components/toolbarBase.vue';
    import { required, between, numeric, minValue, decimal } from 'vuelidate/lib/validators';
    import { apiExtension } from '@/mixins/apiExtension.js';
    import { apiSystemSettingsExtension } from '@/mixins/apiSystemSettingsExtension.js';

    import field_address from '@/components/address.vue';
    import field_image from '@/components/field-image-wd.vue';


    export default {
        name: 'settings',
        mixins: [apiExtension, apiSystemSettingsExtension],
        data: () => ({
            item: null,
            settings: null
        }),
        computed: {
            ready: function () {
                let val = false;

                if (this.item) {
                    //this.currentPhone = this.item.tenantSetting.phone;
                    val = true;
                }

                return val;
            }
        },
        validations: {
            //currentPhone: { required, between: between(999999999, 10000000000) }
        },
        created: function () {
            $App.event.$on("app_hotkey_ctrlS", this.onCtrlS);
        },
        destroyed: function () {
            $App.event.$off("app_hotkey_ctrlS", this.onCtrlS);
        },
        mounted:
            async function () {
                await this.dataRead();
                await this.getAllCategories(); // Trop lent!! j'ai aussi essayé avec @md-changed="tabChanged" mais ça ne charge pas avant l'affichage du tab


                this.settings = this.item.settings
            },
        methods: {

            dataRead: async function () {

                let data = await this.SystemSettingsGet();
                if (data) {
                    this.item = data;
                }
            },
            dataSave: async function () {

                let input = this.cleanItemBeforeSave(this.item);

                let data = await this.SystemSettingsSave(input, null);
                if (data) {
                    // RL need to keep categories before replace this.item with data...
                    this.item.ctrl = data.ctrl;

                    // this.$router.go();
                }
            },
            getAllCategories: async function () {

                if (this.item) {

                    $App.event.$emit("app_running", true)
                    try {
                        for (let setting of this.item.settings) {
                            if (setting.source != null) {

                                let data = await this.httpApiGet(setting.source, false);
                                if (data) {
                                    setting.categories = data;
                                }
                            }
                        }
                    } catch (error) {
                        $App.event.$emit("app_error", error);
                    }
                    $App.event.$emit("app_running", false)
                }
            },
            cleanItemBeforeSave(source) {
                delete source["default"];
                delete source["predefined"];

                for (let setting of source.settings) {
                    if (setting.source != null) {
                        delete setting["categories"];
                    }

                    setting.value = setting.value.toString();
                }

                return source;
            },
            onCtrlS: function (e) {
                //console.log(e);
                this.dataSave();
            },
        },
        components: {
            'toolbar': baseToolbar,
            'field-address': field_address,
            'field-image' : field_image
        }
    };
</script>
